import { css, styled } from 'canoe';

import { WithContentOverflow } from './WithContentOverflow';

export const Content = styled(WithContentOverflow)<{ withSnapshot?: boolean }>`
  ${({ withSnapshot }) => css`
    z-index: 0;
    position: ${withSnapshot ? 'absolute' : 'relative'};
    flex-grow: 1;
    flex-direction: column;
    min-width: 100%;
    min-height: 100%;
  `}
`;
